function EditionExports($el)
{
    this.$el = $el;
    this.$evaluationModal = $('.evaluationModal.modal');
    this.$saiModal = $('.saiModal.modal');

    this.$spinner = $('<i></i>', {
        'class' : 'fa fa-spinner fa-spin',
        'style' : 'margin-right:10px;'
    });

    this.events();
}

EditionExports.prototype.events = function()
{
    var self = this;
    this.$el.on('click', 'a', function(e){
        var $this = $(this);

        if($this.data('method')) {
            e.preventDefault();
            self[$this.data('method')]($this);
        }
    });
}

EditionExports.prototype.evaluation = function($a)
{
    var self = this;

    this.$evaluationModal.modal('show');

    this.$evaluationModal.find('.btn-primary').off('click').on('click', function(){
        $(this).prepend(self.$spinner);

        $.ajax({
            method: 'POST',
            url: $a.attr('href'),
            data: {
                'client' : self.$evaluationModal.find('#client').val(),
                'evaluation_date' : self.$evaluationModal.find('#evaluation_date').val(),
                'language' : self.$evaluationModal.find('#language').val(),
                'type' : self.$evaluationModal.find('#type').val(),
                'location' : self.$evaluationModal.find('#location').val()
            }
        }).done(function( msg ) {
            self.$spinner.remove();
            self.$evaluationModal.modal('hide');

            if(msg.download)
                window.location = msg.download;
        });
    });

    this.$evaluationModal.find('.btn-secondary').off('click').on('click', function(){
        self.$evaluationModal.modal('hide');
    });
}

// EditionExports.prototype.sai = function($a)
// {
//     var self = this;
//
//     this.$saiModal.modal('show');
//
//     this.$saiModal.find('.btn-primary').off('click').on('click', function(){
//         $(this).prepend(self.$spinner);
//
//         $.ajax({
//             method: 'POST',
//             url: $a.attr('href'),
//             data: {
//                 'account' : self.$saiModal.find('#account').val()
//             }
//         }).done(function( msg ) {
//             self.$spinner.remove();
//             self.$saiModal.modal('hide');
//
//             if(msg.download)
//             window.location = msg.download;
//         });
//     });
//
//     this.$saiModal.find('.btn-secondary').off('click').on('click', function(){
//         self.$saiModal.modal('hide');
//     });
// }

$(document).ready(function(){
    var $editionExport = $('[data-edition-exports]');
    if($editionExport.length)
        new EditionExports($editionExport);
});